export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function parseMultipleEmails(val?: string | null): string[] {
  if (!val || !val.trim()) return [];
  return val.split(/[,;\s]+/).filter(Boolean);
}

export function validateMultipleEmails(val?: string | null): boolean {
  const emails = parseMultipleEmails(val);
  if (emails.length === 0) return false;
  return emails.every((email) => EMAIL_REGEX.test(email));
}

export function validateOptionalMultipleEmails(val?: string | null): boolean {
  if (!val || !val.trim()) return true;
  return validateMultipleEmails(val);
}

export function formatMultipleEmails(val?: string | null): string | null {
  const emails = parseMultipleEmails(val);
  return emails.length > 0 ? emails.join(', ') : null;
}

